const locale: Locale = {
  ko: {
    openChat: '오픈 채팅방',
    aboutTeam: 'Infoteam 소개 페이지',

    contact: '문의',
    graduate: '대학원 총학생회',
    emc: '비상대책위원회 소통국',
    Infoteam: 'Infoteam',
  },
  en: {
    openChat: 'Open Chat',
    aboutTeam: 'About Better IT Team',

    contact: 'Contact',
    graduate: 'Graduate Student Union',
    emc: 'Temporary Student Council',
    Infoteam: 'Infoteam',
  },
}

export default locale
